import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const navigate = useNavigate();

  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  const redirectMap = {
    ADMIN: "/user/admin-home-page",
    OPERATIONS: "/user/operations-home-page",
    INSTRUCTOR: "/user/instructor-home-page",
    STUDENT: "/user/student-home-page",
  };


  useEffect(() => {
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    if (!role || !allowedRoles.includes(role)) {
      navigate(redirectMap[role] || "/", { replace: true });
    }
  }, [token, role, allowedRoles, navigate]);

  /* ============================
     🚫 Prevent UI Flash
  ============================ */
  if (!token || !role || !allowedRoles.includes(role)) {
    return null;
  }


  return children;
};

export default ProtectedRoute;